export const maintenancePaths = {
  taskNew: 'nueva',
  taskDetail: ':id',
} as const;
